module.exports = __webpack_public_path__ + "img/payment@3x.4350f012.png";